// extracted by mini-css-extract-plugin
export var appModule = "gU1Tf";
export var fullBleed = "SFQkX";